﻿<script>
  export let className;
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  class={className}>
  <g transform="matrix(1,0,0,1,0,0)">
        <path d="M20.5,3.5v19a1,1,0,0,1-1,1H4.5a1,1,0,0,1-1-1V3.5" fill="none" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M7.5,3.5v-2a1,1,0,0,1,1-1h7a1,1,0,0,1,1,1v2" fill="none" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M0.5 3.5L23.5 3.5" fill="none" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M7.5 7L7.5 19" fill="none" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M12 7L12 19" fill="none" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M16.5 7L16.5 19" fill="none" stroke-linecap="round" stroke-linejoin="round"></path>
    </g>
</svg>
